import { 
  createSliceLayout,
  PageKnowledgeHubLayout,
  PageKnowledgeHubLayoutProps,
  SliceContactFormProps,
  SliceContent,
  SliceContentProps,
  SliceEntityViewAsideMobile,
  SliceEntityViewAsideMobileProps,
  SliceInsetImageBlock,
  SliceInsetImageBlockProps,
  SlicePersonBioGrid,
  SlicePersonBioGridProps,
  SliceVideo,
  SliceConnectionsConversation,
  SliceConnectionsAsideRouteProps,
  SliceConnectionsAsideRoute,
  SliceConnectionsConversationProps,
  SliceIntro,
  SliceIndicatorGroupsMain

} from '@shapeable/ui';
import { SliceExplorerMapSidebar } from '../entities/slice-explorer-map-sidebar';
import { SliceCampaignMonitorContactWidget } from '../entities/slice-campaign-monitor-contact-widget';
import { SlicePersonBanner } from '../entities/slice-person-banner';
import { SliceRaiselyDonateWidget } from '../entities/slice-raisely-donate-widget';
import { SliceContactForm } from '../entities/slice-contct-form';

export const SliceLayoutIndicatorGroupsMain = createSliceLayout(
  SliceIndicatorGroupsMain, {
    boundary: 'explorer',
    verticalPadding: 'none',
  }
);

export const SliceLayoutContent = createSliceLayout<SliceContentProps>(
  SliceContent, {
    verticalPadding: 'small',
  }
);

export const SliceLayoutExplorerMapSidebar = createSliceLayout(
  SliceExplorerMapSidebar, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutCampaignMonitorContactForm = createSliceLayout(
  SliceCampaignMonitorContactWidget, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutRaiselyDonateWidget = createSliceLayout(
  SliceRaiselyDonateWidget, {
    verticalPadding: 'none',
    boundary: 'none',
  }
);

export const SliceLayoutKnowledgeHub = createSliceLayout<PageKnowledgeHubLayoutProps>(
  PageKnowledgeHubLayout, {
    boundary: 'content-bleed',
    verticalPadding: 'medium',
    props: {
      tabsContainerProps: { fadeColor: '#F2EAE2' },
      showAllTab: true,
      entityTypes: { 
        Post: { label: 'Posts', sortBy: 'published', reverse: true }, 
        FeedEntry: { label: 'Articles', sortBy: 'published', reverse: true }, 
        Citation: { label: 'Research', spacing: 4 },
        Video: { label: 'Video', sortBy: 'published', reverse: true },
      }
    }
  }
);

export const SliceLayoutVideo = createSliceLayout(
  SliceVideo, {
    boundary: 'content',
    verticalPadding: 'none',
  }
);

export const SliceLayoutPersonBanner = createSliceLayout(
  SlicePersonBanner, {
    boundary: 'none',
    verticalPadding: 'none',
  }
);

export const SliceLayoutContactForm = createSliceLayout<SliceContactFormProps>(
  SliceContactForm, {
    props: {
      variant: 'inline',
      showMembershipCheckbox: false,
      showSubscribeCheckbox: false,
    }
  }
);

export const SliceLayoutInsetImageBlock = createSliceLayout<SliceInsetImageBlockProps>(
  SliceInsetImageBlock, {
    boundary: 'explorer',
    useEntityColors: false,
    sliceBackgroundColor: '#F2EAE2',
    props: {
      contentEntityBlockProps: {
        iconSize: 150,
        showIcon: false,
      }
    }
  }
);

export const SliceLayoutInsetImageBlockFull = createSliceLayout<SliceInsetImageBlockProps>(
  SliceInsetImageBlock, {
    boundary: 'explorer',
    useEntityColors: false,
    sliceBackgroundColor: '#F2EAE2',
    props: {
      fullWidthBackground: true,
    }
    
  }
);

export const SliceLayoutInsetImageBlockReverse = createSliceLayout<SliceInsetImageBlockProps>(
  SliceInsetImageBlock, {
    boundary: 'explorer',
    useEntityColors: false,
    sliceBackgroundColor: '#F2EAE2',
    props: {
      isReversed: true,
      contentEntityBlockProps: {
        iconSize: 150,
        showIcon: false,
      }
    }
    
  }
);

export const SliceLayoutInsetImageBlockFullReverse = createSliceLayout<SliceInsetImageBlockProps>(
  SliceInsetImageBlock, {
    boundary: 'explorer',
    useEntityColors: false,
    sliceBackgroundColor: '#F2EAE2',
    props: {
      fullWidthBackground: true,
      isReversed: true,
    }
    
  }
);

export const SliceLayoutPeopleWithoutPositions = createSliceLayout<SlicePersonBioGridProps>(
  SlicePersonBioGrid, {
    verticalPadding: 'small',
    props: {
      transform: 'grayscale',
      showPosition: false,
    }
  }
);

export const SliceLayoutEntityViewAsideMobile = createSliceLayout<SliceEntityViewAsideMobileProps>(
  SliceEntityViewAsideMobile, {
    boundary: 'none',
    verticalPadding: 'none',
    props: {
      viewType: 'view',
    }
  }
);

export const SliceLayoutConversation = createSliceLayout<SliceConnectionsConversationProps>(
  SliceConnectionsConversation, {
    boundary: 'none',
    verticalPadding: 'none',
    props: {
      includeActiveEntity: true,
      initialSubView: 'aside',
      usePersonPath: false,
      emptyMessage: 'Comments are incoming...',
      bannerProps: {
        showActiveEntity: false,
        returnToView: 'aside'
      },
      followControlsProps: {
        showModeratingLabels: false
      }
    }
  }
);

export const SliceLayoutConnectionsAsideRoute = createSliceLayout<SliceConnectionsAsideRouteProps>(
  SliceConnectionsAsideRoute, {
    boundary: 'none',
    verticalPadding: 'none',
    props: {
      includeActiveEntity: true,
      // initialSubView: 'Page:General Chat',
    }
  }
);

export const SliceLayoutIntro = createSliceLayout(
  SliceIntro, {
    verticalPadding: 'slim',
  }
);